import { QuantitySelectorComponent } from '@theme/component-quantity-selector';

/**
 * A custom element that allows the user to select a quantity in the cart.
 * Extends QuantitySelectorComponent but uses absolute max limits instead of effective max.
 * Semantics: "What should the total quantity BE in the cart" vs "How many to ADD to cart"
 *
 * @extends {QuantitySelectorComponent}
 */
export class CartQuantitySelectorComponent extends QuantitySelectorComponent {
  /** Remove the last permitted quantity without changing product quantity rules. */
  decreaseQuantity(event) {
    if (!(event.target instanceof HTMLElement)) return;
    if (this.refs.quantityInput.disabled || this.serverDisabledMinus) return;
    const { min, value } = this.getCurrentValues();

    if (value <= min && this.dataset.canRemove !== 'false') {
      event.preventDefault();
      this.refs.quantityInput.value = '0';
      this.onQuantityChange();
      this.updateButtonStates();
      return;
    }

    super.decreaseQuantity(event);
  }

  /**
   * Gets the effective maximum value for cart quantity selector
   * Cart page: uses absolute max (how much can be in cart total)
   * @returns {number | null} The effective max, or null if no max
   */
  getEffectiveMax() {
    const { max } = this.getCurrentValues();
    return max; // Cart uses absolute max, not max minus cart quantity
  }

  /**
   * Updates button states based on current value and limits
   * Keep Shopify restrictions while allowing the last item to be removed.
   */
  updateButtonStates() {
    const { minusButton, plusButton } = this.refs;
    const { min, value } = this.getCurrentValues();
    const effectiveMax = this.getEffectiveMax();

    const locked = this.refs.quantityInput.disabled;
    minusButton.disabled = locked || this.serverDisabledMinus || value <= 0 ||
      (value <= min && this.dataset.canRemove === 'false');
    plusButton.disabled = locked || this.serverDisabledPlus ||
      (effectiveMax !== null && value >= effectiveMax);
  }
}

if (!customElements.get('cart-quantity-selector-component')) {
  customElements.define('cart-quantity-selector-component', CartQuantitySelectorComponent);
}
